import classNames from "classnames";
import Styles from "./Document.module.scss";
import logo from "../../assets/images/logo/LOGO.png";
import socialService from "../../assets/images/index/社工協助.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesRight,
  faBullhorn,
  faHandPointRight,
  faHandshakeAngle,
  faPaperPlane,
  faPeopleGroup,
  faPeopleCarryBox,
  faHandHoldingHeart,
} from "@fortawesome/free-solid-svg-icons";

import { faLine, faFacebook } from "@fortawesome/free-brands-svg-icons";

const Document = () => {
  return (
    <div>
      <div className={classNames("container")}>
        <h2 style={{ textAlign: "center" }}>廣博網站開發文件</h2>
      </div>

      {/* Color */}
      <div className={classNames("container")}>
        <div style={{ marginBottom: "15px" }}>
          <h6 className={classNames(Styles.h6)}> 顏色Color</h6>
          <div className={classNames(Styles.area)}>
            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#816E6E" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#816E6E</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#E6B2BA" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#E6B2BA</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#C0DEFD" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#C0DEFD</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#F1E7E7" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#F1E7E7</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#FFF9F3" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#FFF9F3</p>
            </div>
          </div>

          <div className={classNames(Styles.area)}>
            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#E1E1E1" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#E1E1E1</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#DFDFDF" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#DFDFDF</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#8B8B8B" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#8B8B8B</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#808080" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#808080</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#5E5E5E" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#5E5E5E</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#000000" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#000000</p>
            </div>
          </div>
          <div className={classNames(Styles.area)}>
            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#FFFFFF" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#FFFFFF</p>
            </div>
            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#FFFDFD" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#FFFDFD</p>
            </div>

            <div className={classNames(Styles.color_block)}>
              <div
                style={{ backgroundColor: "#F3F0F0" }}
                className={classNames(Styles.color)}
              ></div>
              <p className={classNames(Styles.param)}>#F3F0F0</p>
            </div>
          </div>
        </div>
      </div>

      {/* Icon */}
      <div className={classNames("container")}>
        <h6 className={classNames(Styles.h6)}> Icon</h6>
        <div className={classNames(Styles.area)}>
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faAnglesRight}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faBullhorn}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faHandPointRight}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faHandshakeAngle}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faPaperPlane}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faPeopleGroup}
          />

          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faPeopleCarryBox}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon)}
            icon={faHandHoldingHeart}
          />
          <FontAwesomeIcon
            className={classNames(Styles.icon__brand)}
            icon={faLine}
          />

          <FontAwesomeIcon
            className={classNames(Styles.icon__brand)}
            icon={faFacebook}
          />
        </div>
      </div>

      {/* Button */}
      <div className={classNames("container")}>
        <h6 className={classNames(Styles.h6)}> 按鈕Button</h6>
        <div className={classNames(Styles.area)}>
          <div className={classNames(Styles.btn)}> default </div>
          <div className={classNames(Styles.btn__primary)}> 看更多 </div>
        </div>
      </div>

      {/* Navbar */}
      <div className={classNames("container")}>
        <h6 className={classNames(Styles.h6)}> 導覽列Navbar</h6>
      </div>
      <div style={{ marginBottom: "15px" }}>
        <nav className={Styles.navbar}>
          <div className={Styles.navbar__brand}>
            <img src={logo} alt="Logo" className={Styles.navbar__logo} />
            <span className={Styles.navbar__title}>
              社團法人中華廣博
              <br />
              長照發展協會
            </span>
          </div>
          <ul className={Styles.navbar__menu}>
            <li>關於我們</li>
            <li>最新消息</li>

            <li>社會服務</li>
            <li>社會責信</li>
            <li>他們的故事</li>
            <li>加入我們</li>
          </ul>
        </nav>
      </div>

      {/* Footer */}
      <div className={classNames("container")}>
        <h6 className={classNames(Styles.h6)}> Footer</h6>
      </div>
      <div style={{ marginBottom: "15px" }}>
        <footer className={classNames(Styles.footer)}>
          <div className={classNames(Styles.footer__title)}>
            <h6>聯絡我們</h6>
          </div>
          <div className={classNames(Styles.footer__bottom)}>
            <div className={classNames(Styles.footer__param)}>
              <p>
                台內團字第1100043798號
                <br />
                聯絡電話：(03)853-0330
                <br />
                地址：花蓮縣吉安鄉文化七街20號
                <br />
                服務時間：周一至周五 8:00-17:00
              </p>
            </div>
            <div className={classNames(Styles.footer__icon)}>
              <FontAwesomeIcon
                className={classNames(Styles.icon__brand)}
                icon={faLine}
              />

              <FontAwesomeIcon
                className={classNames(Styles.icon__brand)}
                icon={faFacebook}
              />
            </div>
          </div>
        </footer>
        <div className={classNames(Styles.footer__copyright)}>
          ©社團法人中華廣博長照發展協會
        </div>
      </div>

      {/* card-1 */}
      <div style={{ marginBottom: "15px" }} className={classNames("container")}>
        <h6 className={classNames(Styles.h6)}> Cards-1</h6>
        <div className={classNames(Styles.card_1__area)}>
          <div className={Styles.card_1}>
            <img
              src={socialService}
              alt="社工服務"
              className={Styles.card_1__image}
            />
            <div className={Styles.card_1__overlay}>
              <span className={Styles.card_1__param}>社工服務</span>
            </div>
          </div>

          <div className={Styles.card_1}>
            <img
              src={socialService}
              alt="社工服務"
              className={Styles.card_1__image}
            />
            <div className={Styles.card_1__overlay}>
              <span className={Styles.card_1__param}>社工服務</span>
            </div>
          </div>

          <div className={Styles.card_1}>
            <img
              src={socialService}
              alt="社工服務"
              className={Styles.card_1__image}
            />
            <div className={Styles.card_1__overlay}>
              <span className={Styles.card_1__param}>社工服務</span>
            </div>
          </div>
        </div>
      </div>

      {/* card-2 */}
      <div style={{ marginBottom: "15px" }} className={classNames("container")}>
        <h6 className={classNames(Styles.h6)}> Cards-2</h6>
        <div className={classNames(Styles.card_2__area)}>
          <div className={Styles.card_2}>
            <div className={Styles.content}>
              <div className={Styles.date}>2025-02-16</div>
              <div className={Styles.title}>
                生命最後的旅程 值得被溫柔對待 ｜ 北榮玉里分院攜手社區
                共築安寧療和照護網
              </div>
              <p className={Styles.description}>
                本會2月16日在玉里舉辦的長照積分課程圓滿落幕，感謝蘇倩瑩護理長為我們帶來一場專業且深入啟發的課程，
                深入講解「安寧緩和醫療」與「預立醫療決定」的重要性。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Document;
